import { createQueryString } from '@eika-infrastruktur/utils';

import type {
    DynamicLinkId,
    PaymentId,
    PaymentItem,
    PaymentItemDetails,
    PaymentItemId,
    PaymentItemStatus,
    PaymentRequest,
    ApprovalResult,
    ApprovalStatus,
    StepUpStatusResponse,
    UpdatePaymentRequest,
} from '../generated-types';
import { CONTEXT_PATH } from './index';
import { post, put, del, get, patch } from './request';

export const pay = (request: PaymentRequest, acceptDuplicate = false): Promise<ApprovalResult> => {
    const url = `${CONTEXT_PATH}/rest/resource/payments`;
    const queryString = createQueryString({
        acceptDuplicate: acceptDuplicate.toString(),
    });
    return post<ApprovalResult>(url + queryString, request);
};

export const checkPayment = async (dynamicLinkId: DynamicLinkId): Promise<ApprovalStatus> => {
    const url = `${CONTEXT_PATH}/rest/resource/payments/${dynamicLinkId.value}`;
    const paymentStatus = await put<ApprovalStatus>(url);
    return paymentStatus === 'CREATED' ? 'PROCESSING' : paymentStatus;
};

export const cancelPayment = (dynamicLinkId: DynamicLinkId): Promise<unknown> => {
    const url = `${CONTEXT_PATH}/rest/resource/payments/${dynamicLinkId.value}`;
    return del(url);
};

export function getPaymentItems(status?: PaymentItemStatus): Promise<PaymentItem[]> {
    const queryString = createQueryString({
        status,
    });
    return get<PaymentItem[]>(`${CONTEXT_PATH}/rest/resource/payments${queryString}`);
}

export const updatePayment = (
    paymentId: PaymentId,
    updatePaymentRequest: UpdatePaymentRequest,
): Promise<ApprovalResult> => {
    return put<ApprovalResult>(
        `${CONTEXT_PATH}/rest/resource/payments/${paymentId.value}/update`,
        updatePaymentRequest,
    );
};

export function getPaymentItemDetails(paymentItemId: PaymentItemId): Promise<PaymentItemDetails> {
    return get<PaymentItemDetails>(`${CONTEXT_PATH}/rest/resource/payments/${paymentItemId.value}`);
}

export function deletePaymentItem(paymentItemId: PaymentItemId): Promise<ApprovalResult> {
    const queryString = createQueryString({
        deviceId: window.ReactNativeProps?.deviceId,
    });
    return del(`${CONTEXT_PATH}/rest/resource/payments/${paymentItemId.value}/stop${queryString}`);
}

export function restartPaymentItem(paymentItemId: PaymentItemId): Promise<unknown> {
    return patch(`${CONTEXT_PATH}/rest/resource/payments/${paymentItemId.value}/restart`);
}

export function getStepUpStatus(deviceId: string): Promise<StepUpStatusResponse> {
    const queryString = createQueryString({
        deviceId,
    });
    return get<StepUpStatusResponse>(`${CONTEXT_PATH}/rest/resource/payments/stepUpStatus${queryString}`);
}
